export const GoogleMapApiConfig = 'AIzaSyALF5FYV_iIskiGnE6pYnNvctXMDdD7NnA';